import axios from "axios";
import {createUrlParams} from "../utils/urlParams";

export const getModels1 = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/models1?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}

export const bulkUpdateModels1 = async (data) => {
    const url = `/api/v1/models1/bulk_update`;
    const res = await axios.put(url, data);
    return res.data;
}

export const createModel1 = async (data) => {
    const url = `/api/v1/models1`;
    const res = await axios.post(url, data);
    return res.data;
}

export const updateModel1 = async (id, data) => {
    const url = `/api/v1/models1/${id}`;
    const res = await axios.patch(url, data);
    return res.data;
}

export const deleteModel1 = async (id) => {
    const url = `/api/v1/models1/${id}`;
    const res = await axios.delete(url);
    return res.data;
}

export const getFailedValidations = async (data) => {
    const url = `/api/v1/models1/failed_validations`;
    const res = await axios.post(url, data);
    return res.data;
}

export const getModel1 = async (id) => {
    const url = `/api/v1/models1/${id}`;
    const res = await axios.get(url);
    return res.data;
}

export const exportModels1 = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/models1/export?${urlParams.toString()}`;
    const res = await axios.get(url, {responseType: 'blob'});
    const disposition = res.headers["content-disposition"];
    const fileName = disposition.split("filename=")[1];
    return {data: res.data, fileName};
}